import { render, staticRenderFns } from "./memberHand.vue?vue&type=template&id=84f2bcf8&scoped=true&"
import script from "./memberHand.vue?vue&type=script&lang=js&"
export * from "./memberHand.vue?vue&type=script&lang=js&"
import style0 from "./memberHand.vue?vue&type=style&index=0&id=84f2bcf8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f2bcf8",
  null
  
)

export default component.exports